import gql from "graphql-tag";
// import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation addSsoUser(
      $username: String!
      $firstName: String
      $lastName: String
      $email: String!
      $roles: [String]!
    ) {
      createSsoUser(
        username: $username
        firstName: $firstName
        lastName: $lastName
        email: $email
        roles: $roles
      ) {
        username
        firstName
        lastName
        email
      }
    }
  `,
  mutationName: "addSsoUser",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/ssoUser/addSsoUser.js